import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "@/store";

type imageState = {
  [key: string]: string[];
};

type imagePayload = {
  key: string;
  value: string;
};

type deletePayload = {
  key: string;
  index: number;
};

const initialState: imageState = {};

const imageSlice = createSlice({
  name: "image",
  initialState,
  reducers: {
    addImage: (state, action: PayloadAction<imagePayload>) => {
      if (state[action.payload.key]) {
        state[action.payload.key].push(action.payload.value);
      } else {
        state[action.payload.key] = [action.payload.value];
      }
    },
    removeImage: (state, action: PayloadAction<deletePayload>) => {
      state[action.payload.key] = state[action.payload.key].filter(
        (_, index) => index !== action.payload.index,
      );
    },
    resetImages: () => initialState,
  },
});

export const { addImage, removeImage, resetImages } = imageSlice.actions;

export const selectImages = (state: RootState) => state.image;
export const selectImageById = (state: RootState, id: string) =>
  state.image[id];

export const imageReducer = imageSlice.reducer;
